import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import RuleForm from '../inputs/RuleForm';
import InlineSupplierSelect from '../inputs/InlineSupplierSelect';
import InlineItemSelect from '../inputs/InlineItemSelect';
import InlineRegionSelect from '../inputs/InlineRegionSelect';


const NonPreferredSupplyGuidance = (props) => {
  const {
    form, type, onSubmit, ...other
  } = props;
  const { initialValues } = props;
  const initialState = {
    supplierIds: initialValues.supplier_ids || [],
    itemIds: initialValues.item_ids || '',
    regions: initialValues.regions && initialValues.regions.length > 0 ? initialValues.regions : [0],
  };

  const [supplierIds, setSupplierIds] = useState(initialState.supplierIds);
  const [itemIds, setItemsIds] = useState(initialState.itemIds);
  const [regions, setRegions] = useState(initialState.regions);

  const handleSubmit = useCallback((event) => {
    event.preventDefault();
    const item_ids = itemIds ? _.map(_.split(itemIds, ','), item => parseInt(item, 10)) : [];
    onSubmit({
      kind: 'non_preferred_supply',
      regions: _.pull(regions, 0),
      value: { supplier_ids: supplierIds, item_ids }
    });
  }, [itemIds, onSubmit, regions, supplierIds]);

  const onReset = useCallback(() => {
    setSupplierIds(initialState.supplierIds);
    setItemsIds(initialState.itemIds);
    setRegions(initialState.regions);
  }, [initialState]);

  return (
    <RuleForm
      {...other}
      onSubmit={handleSubmit}
      onReset={onReset}
      isSubmitting={form.is_submitting}
    >
      <InlineRegionSelect
        onChange={setRegions}
        value={regions}
      />
      <InlineSupplierSelect
        placeholder='All suppliers by default'
        value={supplierIds}
        mode='multiple'
        showSearch={true}
        onChange={setSupplierIds}
        include_all={false}
        include_any={false}
      />
      <InlineItemSelect
        value={itemIds}
        onChange={setItemsIds}
      />
    </RuleForm>
  );
};

NonPreferredSupplyGuidance.defaultProps = {
  type: 'add',
  initialValues: {}
};

NonPreferredSupplyGuidance.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  form: PropTypes.object.isRequired,
  type: PropTypes.string,
  initialValues: PropTypes.object,
};

export default NonPreferredSupplyGuidance;
